import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import AboutMe from './pages/AboutMe.js';
import Milestones from './pages/Milestones.js';
import Main from './pages/Main.js';
import Academia from './pages/Academia.js';
import Experience from './pages/Experience.js';
import Projects from './pages/Projects.js';
import VolunteerExperience from './pages/VolunteerExperience.js';
import Initiatives from './pages/Initiatives.js';
import theme from './theme.js';
import './App.css';

// Array of section data
const sections = [
  { id: 'about-me', component: AboutMe, label: 'About' },
  { id: 'academia', component: Academia, label: 'Academia' },
  { id: 'experience', component: Experience, label: 'Experience' },
  { id: 'milestones', component: Milestones, label: 'Milestones' },
  { id: 'projects', component: Projects, label: 'Projects' },
  { id: 'initiatives', component: Initiatives, label: 'Initiatives' },
  { id: 'volunteer-experience', component: VolunteerExperience, label: 'Volunteer' },
];

const sections_donaji = [
  { id: 'about-me', component: AboutMe, label: 'About' },
  { id: 'milestones', component: Milestones, label: 'Milestones' },
  { id: 'projects', component: Projects, label: 'Projects' },
  { id: 'initiatives', component: Initiatives, label: 'Initiatives' },
];

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ paddingTop: { xs: '70px', md: '84px' } }}>
        <Routes>
          <Route path="/donaji" element={<Main sections={sections_donaji} />} />
          <Route path="*" element={<Main sections={sections} />} />
        </Routes>
      </Box>
    </ThemeProvider>
  );
}

export default App;
